import { useState, useEffect } from 'react';
import CountrySelector from '../components/CountrySelector';
import { Clock, Globe, Users, BookOpen } from 'lucide-react';
import imagegpt from "../assets/ChatGPT.png";
import MeccaLoading from '../components/MeccaLoading';
import { MECCA_TO_CHRIST_NAME, MECCA_TO_CHRIST_URL } from '../data/ministry';

function Home() {
  const [isLoading, setIsLoading] = useState(true);
  
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);
    
    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <MeccaLoading />;
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="text-center mb-12">
        <img src={imagegpt} alt='img' className='gpt-image' />
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
          Welcome to <span className="text-yellow-600">Mecca Prayer House</span>
        </h1>
        <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
          30 days prayer for Muslims in western countries, an initiative of{' '}
          <a
            href={MECCA_TO_CHRIST_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="font-semibold text-yellow-700 underline decoration-yellow-400 underline-offset-2 transition-colors hover:text-red-500"
          >
            {MECCA_TO_CHRIST_NAME}
          </a>
        </p>
      </div>

      <div className="mb-16">
        <CountrySelector />
      </div>

      <div className="mb-12">
        <h2 className="text-3xl font-bold text-center mb-8 text-gray-900">
          What You'll Find Here
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow">
            <div className="bg-yellow-100 p-3 rounded-lg w-fit mb-4">
              <Clock className="h-8 w-8 text-yellow-600" />
            </div>
            <h3 className="text-xl font-bold mb-3">Accurate Prayer Times</h3>
            <p className="text-gray-600 text-sm">
              Calculated using precise astronomical data for each specific location.
            </p>
          </div>
          
          <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow">
            <div className="bg-yellow-100 p-3 rounded-lg w-fit mb-4">
              <Globe className="h-8 w-8 text-yellow-600" />
            </div>
            <h3 className="text-xl font-bold mb-3">Three Countries</h3>
            <p className="text-gray-600 text-sm">
              Comprehensive coverage of USA, Canada, UK, New Zealand and Australia with detailed regional data.
            </p>
          </div>
          
          <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow">
            <div className="bg-yellow-100 p-3 rounded-lg w-fit mb-4">
              <BookOpen className="h-8 w-8 text-yellow-600" />
            </div>
            <h3 className="text-xl font-bold mb-3">Muslim Demographics</h3>
            <p className="text-gray-600 text-sm">
              Detailed information about Muslim populations, mosques, and Quranic schools.
            </p>
          </div>
          
          <div className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow">
            <div className="bg-yellow-100 p-3 rounded-lg w-fit mb-4">
              <Users className="h-8 w-8 text-yellow-600" />
            </div>
            <h3 className="text-xl font-bold mb-3">Community Focused</h3>
            <p className="text-gray-600 text-sm">
              Connecting Muslims with accurate prayer schedules and community information.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;